import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { useReturningUserGreeting } from '@/lib/charles/useReturningUserGreeting';
import { QuickActions, buildQuickActionChips } from './QuickActions';

/**
 * Warm peer-level opener for returning users.
 * Renders nothing unless the feature flag is on AND the user qualifies
 * as "returning" (prior conversation OR open action items).
 */
export function CharlesGreeting() {
  const navigate = useNavigate();
  const { enabled, loading, isReturning, greeting, openActionCount, topActionTitle } =
    useReturningUserGreeting();

  if (!enabled || loading || !isReturning || !greeting) return null;

  const chips = buildQuickActionChips({
    openActionCount,
    topActionTitle,
    onWorkOnTop: () => navigate('/app/employee/charles'),
    onSeeAllTodos: () => navigate('/app/me'),
    onLogPulse: () => navigate('/app/employee'),
    onSeePastConversations: () => navigate('/app/me'),
    onSomethingElse: () => navigate('/app/employee/charles'),
  });

  return (
    <Card>
      <CardContent className="p-4 sm:p-5 space-y-3">
        <p
          className="text-base sm:text-lg font-heading text-foreground leading-snug"
          data-testid="charles-greeting"
        >
          {greeting.text}
        </p>
        <QuickActions chips={chips} />
      </CardContent>
    </Card>
  );
}
